import React from 'react';
import './FilterStyles.css';

const SOCIAL_GRADES = ['AB', 'C1', 'C2', 'DE'];

const SocialGradeFilter = ({ filter, onUpdate, onRemove }) => {
  const { grades = [] } = filter.values;

  const handleToggle = (grade) => {
    const newGrades = grades.includes(grade)
      ? grades.filter(g => g !== grade)
      : [...grades, grade];

    onUpdate({
      ...filter,
      values: { ...filter.values, grades: newGrades }
    });
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <h3>Social Grade</h3>
        <button className="filter-remove-btn" onClick={onRemove}>×</button>
      </div>

      <div className="filter-section">
        {SOCIAL_GRADES.map(grade => (
          <label key={grade} className="filter-checkbox">
            <input
              type="checkbox"
              checked={grades.includes(grade)}
              onChange={() => handleToggle(grade)}
            />
            <span>{grade}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default SocialGradeFilter;
